import { days } from "../../cpcoc/days";
import { getActiveDate } from "./dates";
import { getCalendarOffset } from "./getCalendarOffset";
import { getDateContent } from "./getDataContent";
import { getDateState } from "./getDateState";
import { getDaysInMonth } from "./getDaysInMonth";
import { getDaysOnCalendar } from "./getDaysOnCalendar";
import { getPlanByDate } from "./readingPlan";
import { getOutsideCalendar } from "./setOutsideCalendar";
export function monthBody() {
    let html = "";
    const activeDate = getActiveDate();
    const year = activeDate.getFullYear();
    const month = activeDate.getMonth();
    const outsideCalendar = getOutsideCalendar();
    const daysInMonth = getDaysInMonth(year, month);
    const calendarOffset = getCalendarOffset(year, month);
    const totalDaysOnCalendar = getDaysOnCalendar(daysInMonth, calendarOffset);
    let statusClass = "";
    for (let i = calendarOffset; i < totalDaysOnCalendar; i++) {
        const thisDate = new Date(year, month, i + 1);
        const date = thisDate.getDate();
        const day = thisDate.getDay();
        const plan = getPlanByDate(thisDate);
        const content = getDateContent(plan);
        let outsideCalendarContent = "";
        if (day === 0) {
            // start row
            html += "<tr>";
        }
        statusClass = getDateState(thisDate);
        if (i < 0 || i >= daysInMonth) {
            let eye = "fa-eye";
            statusClass = "not-month";
            if (outsideCalendar) {
                statusClass += " showDate";
                eye = "fa-eye-slash";
            }
            const eyeMsg = `Click to ${eye === "fa-eye" ? "show" : "hide"} reading outside of month.`;
            outsideCalendarContent += `
          <button class="bible-reading__outside-calendar-toggle" title="${eyeMsg}" value="${!outsideCalendar}">
            <i class="fa-solid ${eye}"></i>
          </button> 
        `;
        }
        html += `
        <td class="${statusClass}">
          <div class="date-content">
            <p class="date">${date}</p>
            <article class="bible-reading__template">
              ${content}
            </article>
          </div>
          ${outsideCalendarContent}
        </td>
      `;
        if (day === days.length - 1) {
            // end row
            html += "</tr>";
        }
    }
    return html;
}
